import { render, staticRenderFns } from "./ProfileCompletionForm.vue?vue&type=template&id=675a9456&scoped=true&"
import script from "./ProfileCompletionForm.vue?vue&type=script&lang=ts&"
export * from "./ProfileCompletionForm.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileCompletionForm.vue?vue&type=style&index=0&id=675a9456&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675a9456",
  null
  
)

export default component.exports